import { FC, useState, createContext, useContext, useCallback } from 'react'
import {
  QueryState,
  QueryRequestContextProps,
  initialQueryRequest,
  WithChildren,
} from '../../../../../../_metronic/helpers'

const QueryRequestContext = createContext<QueryRequestContextProps>(initialQueryRequest)

export const QueryRequestProvider: FC<WithChildren> = ({ children }) => {
  const initialState: QueryState = {
    ...initialQueryRequest.state,
    // Chave única de ordenação da fila: o backend aplica cor da triagem -> paciente online ->
    // tempo de espera (T4 AC2). Mandar pacienteOnline/solicitacao daqui competiria com essa ordem.
    fixedSort: [{ field: 'riscoTriagem', order: 'desc' }],
    search: 'estado:1',
  }
  const [state, setState] = useState<QueryState>(initialState)

  const updateState = useCallback(
    (updates: Partial<QueryState>) =>
      setState((prev) => ({
        ...prev,
        ...updates,
      })),
    []
  )

  return (
    <QueryRequestContext.Provider value={{ state, updateState }}>
      {children}
    </QueryRequestContext.Provider>
  )
}

export const useQueryRequest = () => useContext(QueryRequestContext)
